import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {createTicketMutation, CreateTicketInput} from './__generated__/createTicketMutation.graphql';

const mutation = graphql`
	mutation createTicketMutation($input: CreateTicketInput!, $connections: [ID!]!) {
		createTicket(input: $input) {
			clientMutationId
			ticketEdge @appendEdge(connections: $connections) {
				cursor
				node {
					id
					slug
					...TicketRow_ticket
				}
			}
		}
	}
`;

export interface CreateTicketCommitInput extends CreateTicketInput {
	connections: string[];
}

function commit(
	environment: Environment,
	input: CreateTicketCommitInput,
	onCompleted?: (r: createTicketMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	const {connections, ...rest} = input;
	return commitMutation<createTicketMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...rest},
			connections,
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'createTicketMutation'};
